const memoryStore = new Map();

const memoryAdapter = {
  getItem: (key) => (memoryStore.has(key) ? memoryStore.get(key) : null),
  setItem: (key, value) => {
    memoryStore.set(key, String(value));
  },
  removeItem: (key) => {
    memoryStore.delete(key);
  },
  clear: () => {
    memoryStore.clear();
  },
};

const canUseStorage = (candidate) => {
  if (!candidate) return false;
  try {
    const testKey = "__storage_test__";
    candidate.setItem(testKey, "1");
    candidate.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

let resolvedStore = null;

const resolveStore = () => {
  if (resolvedStore) return resolvedStore;
  if (typeof window === "undefined") {
    resolvedStore = memoryAdapter;
    return resolvedStore;
  }
  if (canUseStorage(window.localStorage)) {
    resolvedStore = window.localStorage;
    return resolvedStore;
  }
  if (canUseStorage(window.sessionStorage)) {
    resolvedStore = window.sessionStorage;
    return resolvedStore;
  }
  resolvedStore = memoryAdapter;
  return resolvedStore;
};

export const storage = {
  get: (key) => resolveStore().getItem(key),
  set: (key, value) => resolveStore().setItem(key, String(value)),
  remove: (key) => resolveStore().removeItem(key),
  clear: () => {
    const store = resolveStore();
    if (typeof store.clear === "function") {
      store.clear();
      return;
    }
    memoryAdapter.clear();
  },
};
